
import { defineComponent } from 'vue';
import FbxButton from '@/components/fbx-button.vue';
import VirtualRedTagHeader from '@/components/VirtualRedTag/VirtualRedTagHeader.vue';
import VirtualRedTagTrailerGraphic from '@/components/VirtualRedTag/VirtualRedTagTrailerGraphic.vue';
import trailerByNumber from '@/shared/mixins/trailerByNumber';
import {
    VirtualRedTagNotificationQuery,
    VirtualRedTagNotificationRoute,
} from '@/types/VirtualRedTagNotification';
import { VirtualRedTagTrailerGraphicState } from '@/types/VirtualRedTagTrailerGraphicState';

export default defineComponent({
    name: 'VirtualRedTagRedTagged',
    components: {
        FbxButton,
        VirtualRedTagHeader,
        VirtualRedTagTrailerGraphic,
    },
    mixins: [trailerByNumber],
    props: {
        // The red tag just submitted; notification preferences are saved against it.
        assessmentId: {
            type: String,
            default: undefined,
        },
    },
    async created(): Promise<void> {
        await this.fetchTrailerByNumber();
    },
    computed: {
        GraphicState(): typeof VirtualRedTagTrailerGraphicState {
            return VirtualRedTagTrailerGraphicState;
        },
    },
    methods: {
        navigateToNotifications(): void {
            this.$router.push({
                name: VirtualRedTagNotificationRoute.method,
                params: { trailerNumber: this.trailerNumber },
                query: {
                    [VirtualRedTagNotificationQuery.assessmentId]:
                        this.assessmentId,
                },
            });
        },
        navigateToWelcome(): void {
            this.$router.push({ name: 'VirtualRedTagEntry' });
        },
    },
});
